import React from "react";
import {
  Dialog,
  FlatButton,
  IconButton,
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
} from "material-ui";
import { FormattedMessage } from "react-intl";
import Clear from "material-ui/svg-icons/content/clear";
import Button from "./Button";
import AddGroup from "./AddGroup";
import images from "../../config/images";

class EditGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAddGroup: false,
      isEdit: false,
      selectedGroup: {},
    };
  }


  editGroup = (group) => {
    this.setState({ isEdit: true, selectedGroup: group }, () => {
      this.setState({ openAddGroup: true });
    });
  };

  render() {
    const tdStyle = {
      padding: "0 8px",
      borderRight: "1px solid #b8b8b8",
      textAlign: "center",
      whiteSpace: "pre-wrap",
      overflow: "visible",
      color: "#657285",
      wordBreak: 'break-all'
    };

    let title = (
      <div
        style={{
          backgroundColor: "#657285",
          padding: "12px 16px",
          color: "#fff",
        }}
        className="d-flex align-center justify-between"
      >
        <span style={{ fontSize: "15px" }}>
          <FormattedMessage id="emailAddressBook.editGroup" />
        </span>
        <div className="flex-center">
          <Button
            label={<FormattedMessage id="emailAddressBook.addNewGroup" />}
            help={false}
            noSpacing={true}
            handleButtonClick={() => this.setState({ openAddGroup: true })}
          />
          <Clear
            onClick={this.props.handleClose}
            style={{
              fill: "#fff",
              cursor: "pointer",
              width: "30px",
              height: "30px",
            }}
          />
        </div>
      </div>
    );

    return (
      <Dialog
        modal={false}
        title={title}
        open={this.props.open}
        onRequestClose={this.props.handleClose}
        contentClassName="popup-modal-content"
        contentStyle={{ maxWidth: "550px", width: "96%" }}
        bodyStyle={{ padding: 0 }}
        autoScrollBodyContent={true}
        className="popup-modal"
        bodyClassName="popup-modal-body"
      >
        {this.state.openAddGroup && <AddGroup
          open={this.state.openAddGroup}
          isEdit={this.state.isEdit}
          selectedGroup={this.state.selectedGroup}
          groups={this.props.groups}
          handleClose={() => this.setState({ openAddGroup: false, isEdit: false, selectedGroup: {}})}
          emailAddressBook={this.props.emailAddressBook}
          onSuccess={() => {
            this.setState({ openAddGroup: false, isEdit: false, selectedGroup: {} })
            this.props.onGroupUpdate();
          }}
        />}
        <div
          style={{
            backgroundColor: "rgb(241, 241, 241)",
            padding: "20px 30px 30px 20px",
          }}
        >
          <Table
            selectable={false}
            selectedColor="black"
            style={{ border: "1px solid #b8b8b8" }}
          >
            <TableBody deselectOnClickaway={false} displayRowCheckbox={false}>
              <TableRow
                style={{
                  border: "1px solid #b8b8b8",
                  backgroundColor: "#6B7c93",
                  color: "#fff",
                }}
              >
                <TableRowColumn colSpan={3} style={{...tdStyle, color: '#fff'}}>
                  {<FormattedMessage id="emailAddressBook.groupName" />}
                </TableRowColumn>
                <TableRowColumn style={{...tdStyle, color: '#fff'}}>
                  {<FormattedMessage id="emailAddressBook.edit" />}
                </TableRowColumn>
              </TableRow>

              {this.props.groups.length == 0 && (
                <TableRow
                  selected={false}
                  className="dark-row"
                  style={{
                    backgroundColor: "#f2f3f6",
                    borderBottom: "1px solid #b8b8b8",
                  }}
                >
                  <TableRowColumn colSpan={4} style={tdStyle}>
                    <p className="room-name"><FormattedMessage id="emailAddressBook.noGroups" /></p>
                  </TableRowColumn>
                </TableRow>
              )}

              {this.props.groups.map((group, index) => {
                return (
                  <TableRow
                    key={index}
                    selected={false}
                    className={index % 2 == 0 ? "dark-row" : "light-row"}
                    style={{
                      backgroundColor: "#f2f3f6",
                      borderBottom: "1px solid #b8b8b8",
                    }}
                  >
                    <TableRowColumn colSpan={3} style={tdStyle}>
                      {group.name}
                    </TableRowColumn>
                    <TableRowColumn style={tdStyle}>
                      <IconButton
                        onClick={(e) => this.editGroup(group)}
                        iconStyle={{ height: "23px" }}
                        touchRippleColor="red"
                      >
                        <img src={images.editIcon} />
                      </IconButton>
                    </TableRowColumn>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </Dialog>
    );
  }
}

export default EditGroup;



// WEBPACK FOOTER //
// src/components/EmailAddressBook/EditGroup.js